export type CleanObservations = () => Promise<Record<'string', never>>
